import React, { useContext, useEffect } from "react";
import { Modal } from "antd";
import { useState } from "react";
import ModalHeaderLayout from "../../../layouts/ModalHeaderLayout";
import UserContext from "../../../Context/UserContext";
import axios from "axios";
import { apiUrl } from "../../../config";
import { useTranslation } from "react-i18next";

const MalzemeKoduModalFront = ({
  modalOpen,
  setModalOpen,
  selectedRow,
  rule,
  setRefreshPage,
  refreshPage,
  getColor,
  frontBodyMaterialType
}) => {
  const { t } = useTranslation();
  const username = process.env.REACT_APP_USERNAME;
  const password = process.env.REACT_APP_SECRET_KEY;

  const [formData1, setFormData1] = useState({
    malzeme_kodu: "",
    tanim: "",
    min_inventory_periodically: "",
    put_inventory_before_demand: "",
    production_rate_according_demand: "",
    par_obj_func_stop_exceeding_demand: "",
    front_body_color: "",
    front_body_material_type: "",
    is_service: "",
  });

  useEffect(() => {
    if (selectedRow && rule === "changeOrder") {
      setFormData1({
        malzeme_kodu: selectedRow.malzeme_kodu,
        tanim: selectedRow.tanim,
        min_inventory_periodically: selectedRow.min_inventory_periodically,
        put_inventory_before_demand: selectedRow.put_inventory_before_demand,
        production_rate_according_demand: selectedRow.production_rate_according_demand,
        par_obj_func_stop_exceeding_demand: selectedRow.par_obj_func_stop_exceeding_demand,
        front_body_color: selectedRow.front_body_colorid,
        front_body_material_type: selectedRow.front_body_material_typeid,
        is_service: selectedRow.is_service,
      });
    } else {

      setFormData1({
        malzeme_kodu: "",
        tanim: "",
        min_inventory_periodically: "",
        put_inventory_before_demand: "",
        production_rate_according_demand: "",
        par_obj_func_stop_exceeding_demand: "",
        front_body_color: "",
        front_body_material_type: "",
        is_service: "",
      });
    }
  }, [selectedRow, modalOpen]);


  // HATA STATE VE SAĞLAM BOŞ KONTROLÜ
  const [errors, setErrors] = useState({});
  const isEmptyValue = (v) => {
    if (v === null || v === undefined) return true;
    if (typeof v === "string") return v.trim() === "";
    return false;
  };

  useEffect(() => {
    if (modalOpen) {
      setErrors({}); // modal açılırken uyarıları temizle
    }
  }, [modalOpen, rule, selectedRow]);

  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setFormData1({ ...formData1, [name]: value });
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: undefined })); // alan değişince ilgili hatayı temizle
    }
  };

  // SUBMIT ÖNCESİ DOĞRULAMA
  const validateForm = () => {
    const f = formData1;
    const errs = {};
    if (isEmptyValue(f.malzeme_kodu)) errs.malzeme_kodu = `${t("constraints.materialCode")} ${t("constraints.isRequired")}`;
    if (isEmptyValue(f.tanim)) errs.tanim = `${t("constraints.description")} ${t("constraints.isRequired")}`;
    if (isEmptyValue(f.min_inventory_periodically)) errs.min_inventory_periodically = `${t("constraints.minInventoryPeriodically")} ${t("constraints.isRequired")}`;
    if (isEmptyValue(f.put_inventory_before_demand)) errs.put_inventory_before_demand = `${t("constraints.putInventoryBeforeDemand")} ${t("constraints.isRequired")}`;
    if (isEmptyValue(f.production_rate_according_demand)) errs.production_rate_according_demand = `${t("constraints.productionRateAccordingDemand")} ${t("constraints.isRequired")}`;
    if (isEmptyValue(f.par_obj_func_stop_exceeding_demand)) errs.par_obj_func_stop_exceeding_demand = `${t("constraints.parObjFuncStopExceedingDemand")} ${t("constraints.isRequired")}`;
    if (isEmptyValue(f.is_service)) errs.is_service = `${t("constraints.isService")} ${t("constraints.isRequired")}`;
    if (isEmptyValue(f.front_body_color)) errs.front_body_color = `${t("constraints.frontBodyColor")} ${t("constraints.isRequired")}`;
    if (isEmptyValue(f.front_body_material_type)) errs.front_body_material_type = `${t("constraints.frontBodyType")} ${t("constraints.isRequired")}`;
    return errs;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // DOĞRULAMA VE UYARILAR
    const errs = validateForm();
    setErrors(errs);
    if (Object.keys(errs).length > 0) return;

    const requestMethod = rule === "changeOrder" ? axios.put : axios.post;

    let requestData;

    if (rule === "changeOrder") {
      requestData = { ...formData1, id: selectedRow.id };
    }
    if (rule === "newOrder") {
      requestData = formData1;
    }

    requestMethod(`${apiUrl}${window.location.pathname === "/simulasyon" ? "/beta" : ""}/addFrontBodyMaterial`,
      requestData, {
      headers: {
        Authorization: `Basic ${btoa(`${username}:${password}`)}`
      }
    })
      .then(res => {
        if (res.status === 200) {
          setFormData1({
            malzeme_kodu: selectedRow.malzeme_kodu || "",
            tanim: selectedRow.tanim || "",
            min_inventory_periodically: selectedRow.min_inventory_periodically || "",
            put_inventory_before_demand: selectedRow.put_inventory_before_demand || "",
            production_rate_according_demand: selectedRow.production_rate_according_demand || "",
            par_obj_func_stop_exceeding_demand: selectedRow.par_obj_func_stop_exceeding_demand || "",
            front_body_color: selectedRow.front_body_colorid,
            front_body_material_type: selectedRow.front_body_material_typeid,
            is_service: selectedRow.is_service,
          });
          setErrors({}); // başarılı submit sonrası uyarıları temizle
          setModalOpen(false)
          setRefreshPage(!refreshPage);
        }
      })
      .catch(err => console.log(err));
  }

  return (
    <Modal
      title=<ModalHeaderLayout title={rule === "changeOrder" ? t("constraints.changeMaterialCode") : t("constraints.addFrontBodyMaterial")} />
      open={modalOpen}
      footer={null}
      onOk={() => setModalOpen(false)}
      onCancel={() => {
        setModalOpen(false);
        setErrors({}); // kapatırken uyarıları temizle
      }}
      centered
      className="min-w-max mb-40"
    >
      <form className='bg-surface pl-10 pr-10 pb-10 rounded-2xl shadow-2xl' onSubmit={handleSubmit}>
        <div className='grid laptop:grid-cols-2 desktop:grid-cols-3 largeDesktop:grid-cols-4 gap-7'>
          <div>
            <label htmlFor="malzeme_kodu">{t("constraints.materialCode")}</label>
            <input onChange={(e) => handleChange1(e)} onWheel={(e) => e.target.blur()} type="number" min="0" name="malzeme_kodu" value={formData1.malzeme_kodu} className="bg-gray-200 rounded h-8 block w-full mt-1" />
            {errors.malzeme_kodu && <div className="text-red-600 text-xs mt-1">{errors.malzeme_kodu}</div>}
          </div>
          <div>
            <label htmlFor="tanim ">{t("constraints.description")}</label>
            <input onChange={(e) => handleChange1(e)} type="text" name="tanim" value={formData1.tanim} className="bg-gray-200 rounded h-8 block w-full mt-1" />
            {errors.tanim && <div className="text-red-600 text-xs mt-1">{errors.tanim}</div>}
          </div>
          <div>
            <label htmlFor="min_inventory_periodically">{t("constraints.minInventoryPeriodically")}:</label>
            <input onChange={(e) => handleChange1(e)} onWheel={(e) => e.target.blur()} type="number" min="0" name="min_inventory_periodically" value={formData1.min_inventory_periodically} className="bg-gray-200 rounded h-8 block w-full mt-1" />
            {errors.min_inventory_periodically && <div className="text-red-600 text-xs mt-1">{errors.min_inventory_periodically}</div>}
          </div>
          <div>
            <label htmlFor="fname1">{t("constraints.putInventoryBeforeDemand")}:</label>
            <input onChange={(e) => handleChange1(e)} onWheel={(e) => e.target.blur()} type="number" min="0" name="put_inventory_before_demand" value={formData1.put_inventory_before_demand} className="bg-gray-200 rounded h-8 block w-full mt-1" />
            {errors.put_inventory_before_demand && <div className="text-red-600 text-xs mt-1">{errors.put_inventory_before_demand}</div>}
          </div>
          <div>
            <label htmlFor="fname1">{t("constraints.productionRateAccordingDemand")}:</label>
            <input onChange={(e) => handleChange1(e)} onWheel={(e) => e.target.blur()} type="number" step="any" min="0" name="production_rate_according_demand" value={formData1.production_rate_according_demand} className="bg-gray-200 rounded h-8 block w-full mt-1" />
            {errors.production_rate_according_demand && <div className="text-red-600 text-xs mt-1">{errors.production_rate_according_demand}</div>}
          </div>
          <div>
            <label htmlFor="fname1">{t("constraints.parObjFuncStopExceedingDemand")}:</label>
            <input onChange={(e) => handleChange1(e)} onWheel={(e) => e.target.blur()} type="number" min="0" name="par_obj_func_stop_exceeding_demand" value={formData1.par_obj_func_stop_exceeding_demand} className="bg-gray-200 rounded h-8 block w-full mt-1" />
            {errors.par_obj_func_stop_exceeding_demand && <div className="text-red-600 text-xs mt-1">{errors.par_obj_func_stop_exceeding_demand}</div>}
          </div>
          <div>
            <label htmlFor="is_service">{t("constraints.isService")}</label>
            <select onChange={(e) => handleChange1(e)} name="is_service" value={formData1.is_service} className="bg-gray-200 rounded h-8 block w-full mt-1">
              <option value="">{t("constraints.select")}</option>
              <option value="true">{t("constraints.yes")}</option>
              <option value="false">{t("constraints.no")}</option>
            </select>
            {errors.is_service && <div className="text-red-600 text-xs mt-1">{errors.is_service}</div>}
          </div>
          <div>
            <label htmlFor="front_body_color">{t("constraints.frontBodyColor")} :</label>
            <select onChange={(e) => handleChange1(e)} name="front_body_color" value={formData1.front_body_color} className="bg-gray-200 rounded h-8 block w-full mt-1">
              <option value="">{t("constraints.select")}</option>
              {getColor && getColor.map((item, index) => {
                return <option key={index} value={item.id}>{item.description}</option>
              })}
            </select>
            {errors.front_body_color && <div className="text-red-600 text-xs mt-1">{errors.front_body_color}</div>}
          </div>
          <div>
            <label htmlFor="front_body_material_type">{t("constraints.frontBodyType")} :</label>
            <select onChange={(e) => handleChange1(e)} name="front_body_material_type" value={formData1.front_body_material_type} className="bg-gray-200 rounded h-8 block w-full mt-1">
              <option value="">{t("constraints.select")}</option>
              {frontBodyMaterialType && frontBodyMaterialType.map((item, index) => {
                return <option key={index} value={item.id}>{item.description}</option>
              })}
            </select>
            {errors.front_body_material_type && <div className="text-red-600 text-xs mt-1">{errors.front_body_material_type}</div>}
          </div>
        </div>
        <div>
          <button type="submit" className="bg-smartopt hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-10 w-full">{t("singularParameters.submit")}</button>
        </div>
      </form>
    </Modal>
  );
};

export default MalzemeKoduModalFront;

